/**
* Gére une iFrame imitant le comportement du WebView ProLexis.
**/
<template>
	<iframe id="iframe_variants" :src="iframe_src"> </iframe>
</template>

<script>
	import { diagonalbackURL } from "../constantes";

	export default {
		name: 'WebViewProLexis',

		props: {
			settingId:   { type: Number, required: true },
			path:        { type: String, required: true },
			queryString: { type: String, required: false, default: '' },
		},
		emits: ['msg'],

		mounted() {
			// On écoute les messages émis depuis l'iframe
			//
			window.addEventListener('message', this.handleMessageFromIframe);
		},
		unmounted() {
			// On retire le handler 
			//
			window.removeEventListener('message', this.handleMessageFromIframe);
		},

		computed: {
			iframe_src : function ()
			{
				return diagonalbackURL + this.path + '?setting=' + this.settingId + '&referer='+ window.location.protocol +'//'+ window.location.host + (this.queryString == '' ? '' : '&'+ this.queryString);
			}
		},
		methods: {
			handleMessageFromIframe(iEvent)
			{
				// A trouver un test permettant de savoir que les messages proviennent bien de notre
				// iframe.
				//
				if (typeof iEvent.data == 'string') {
					var aData = {};

					try {
						aData = JSON.parse(iEvent.data);
					}
					catch (e) {
						return;
					}
					
					switch(aData.msg) {
						// Vérification que le token est toujours actif
						//
						case 'credential':
							// Le token est à renouveller
							//
							if (this.$store.getters.isRefreshValid) {
								var aStore = this.$store;
								this.$store.dispatch('refresh').then(function(){
									iEvent.source.postMessage(JSON.stringify({
										msg: 'credential',
										token: aStore.getters.tokenInfo.token}), iEvent.origin);
								});
							}
							else {
								iEvent.source.postMessage(JSON.stringify({
									msg: 'credential',
									token: this.$store.getters.tokenInfo.token
								}), iEvent.origin);	
							}
							
						break;

						// Modification
						//
						case 'change':
							this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
						break;
					}

					// Propager l'événement
					//
					this.$emit('msg', aData, iEvent);
				}
			} // handleMessageFromIframe
		}
	}
</script>

<style >
#iframe_variants {
	width: 100%;
	height: calc(100% - 48px);
	border: 1px solid #EFEFEF;
	border-bottom: none;
}


</style>